import React from 'react';

type Props = {
  onChange: Function;
  isChecked: boolean;
};

export function HideCollectedCheckbox({ onChange, isChecked }: Props) {
  return (
    <div style={{ marginTop: 16, marginBottom: 16 }}>
      <label
        style={{
          display: 'flex',
          alignItems: 'center',
          width: 200,
          paddingLeft: 10,
        }}
      >
        <input
          style={{ marginRight: 8 }}
          type="checkbox"
          onClick={() => onChange(!isChecked)}
        />
        Hide collected
      </label>
    </div>
  );
}
